import React, { useEffect, useState } from 'react';
import { Alert, Button, Input, Typography } from 'antd';
import QRCode from 'qrcode';
import { LYNEAR_PRIMARY, NEUTRAL } from '../config/palette.js';

const { Paragraph, Text } = Typography;

/** The secret in groups of four, for someone typing it into an app. */
const grouped = (secret) => secret.replace(/(.{4})/g, '$1 ').trim();

/**
 * The authenticator's setup (IP-74): the QR code of the otpauth URI the
 * Console API returned - the secret Cognito issued, which the Core also keeps
 * for step-up - the same secret as text for typing, and the first code.
 *
 * The secret is shown once and held only in this component's props; it is
 * never stored, and leaving the step drops it.
 */
const MfaSetup = ({ secret, otpauthUri, busy, error, onVerify, onCancel }) => {
    const [src, setSrc] = useState('');
    const [codeKey, setCodeKey] = useState(0);

    useEffect(() => {
        let cancelled = false;
        QRCode.toDataURL(otpauthUri, { margin: 1, width: 196, errorCorrectionLevel: 'M', color: { dark: LYNEAR_PRIMARY.ink, light: NEUTRAL.white } })
            .then((url) => {
                if (!cancelled) setSrc(url);
            })
            .catch(() => {
                if (!cancelled) setSrc('');
            });
        return () => {
            cancelled = true;
        };
    }, [otpauthUri]);

    // A wrong code clears the boxes for the next attempt.
    useEffect(() => {
        if (error) setCodeKey((k) => k + 1);
    }, [error]);

    return (
        <div className="auth-otp auth-setup">
            <Paragraph className="auth-setup-subtext">
                Open Google Authenticator or Microsoft Authenticator, choose to add an account, and scan this code.
            </Paragraph>
            {src ? <img src={src} alt="Authenticator setup QR code" className="auth-qr" /> : null}
            <Paragraph type="secondary" className="auth-secret auth-setup-subtext">
                Cannot scan it? Enter this key instead:<br />
                <Text code copyable={{ text: secret }}>{grouped(secret)}</Text>
            </Paragraph>
            {error && <Alert type="error" showIcon message={error} className="auth-alert" />}
            <Paragraph className="auth-setup-subtext">Then enter the 6-digit code the app shows.</Paragraph>
            <Input.OTP key={codeKey} length={6} size="large" disabled={busy} onChange={onVerify} autoFocus />
            <div className="auth-otp-actions">
                <Button type="link" onClick={onCancel} disabled={busy}>
                    Start again
                </Button>
            </div>
        </div>
    );
};

export default MfaSetup;
